import Product from './Product/Product';


const AnalyticConfig = {
    settings: {
      layout: {},
    },
    routes: [
      {
        path: 'analytic',
        element: <Product />,
      }
    ],
  };
  
  export default AnalyticConfig;
